<template>
  <div class="row">
    <div class='col' style="border-right: 1px solid #e0e0e0">
      <h6 class="heading-small text-muted mb-2">Search by terminal name</h6>
      <a-input-search @keyup.enter="changeTerminalFilter" @search="changeTerminalFilter" placeholder="Search by terminal name" v-model='terminalSearchInput'/>

      <hr class="my-4" />
      <h6 class="heading-small text-muted mb-2">Filter by sync status</h6>
      <div>
        <a-radio-group defaultValue='0' @change="changeSyncFilter">
          <a-radio value="0">All</a-radio> <br>
          <a-radio value="Yes">Synced</a-radio> <br>
          <a-radio value="No">Not Synced</a-radio>
        </a-radio-group>
      </div>
    </div>
    
    <div class="col-10">
      <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
        <div class="card-header border-0" :class="type === 'dark' ? 'bg-transparent': ''">
          <div class="row align-items-center">
            <div class="col-md-3">
              <h3 class="mb-0" :class="type === 'dark' ? 'text-white': ''">
                {{_.startCase(currentProfile)}}
              </h3>
            </div>
          </div>
        </div>
        <div class="table-responsive px-4">
          <VueTabulator ref="tabulator" v-model="data" :options="options" />
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
  import axios from "axios";
  import { mapState } from 'vuex'
  import secureStorage from '../../controllers/secureStorage';
  import HTTPRequest from '../../controllers/httpRequest.js';

  var component_x;

  export default {
    name: 'profiles-table',
    props: {
      type: {
        type: String
      },
      title: String
    },
    components: {

    },
    computed: {
      ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters', 'serverType', 'profileId'])
    },
    data() {
      return {
        data: [],
        options: {
          layout:"fitDataStretch",
          pagination:"local",
          paginationSize:10,
          columns:[
            {title: 'Synced', field: "is_latest", align:'center', formatter: this.is_latest_formatter, headerSort:false},
            {title: 'Terminal Name', field: 'terminal_code', headerSort:false},
            {title: 'Terminal Full Sync Counter', field: "terminal_full_counter", align:'center', headerSort:false},
            {title: 'Terminal Full Timestamp',  field: 'terminal_full_timestamp', headerSort:false},
            //{title: 'Job Status', field: 'sync_status', headerSort:false},
          ],
        },
        terminalSearchInput: '',
      }
    },
    watch: {
      currentApiURL: function () {
        this.apiURL = this.currentApiURL
      },
      parameters: function () {
        this.apiURL = this.currentApiURL
        this.apiURL = this.apiURL + this.parameters
      }
    },
    methods: {
      changeSyncFilter(e){
        var tabulatorInstance = this.$refs.tabulator.getInstance();
        var filter_sync_status = e.target.value
        if (filter_sync_status=="Yes") {
          tabulatorInstance.clearFilter();
          tabulatorInstance.addFilter("is_latest", "like", filter_sync_status);
        } else if (filter_sync_status=="No"){
          tabulatorInstance.clearFilter();
          tabulatorInstance.addFilter("is_latest", "like", filter_sync_status);
        } else {
          tabulatorInstance.clearFilter();
        }
      },
      changeTerminalFilter(val){
        var tabulatorInstance = this.$refs.tabulator.getInstance();
        if (this.terminalSearchInput){
            tabulatorInstance.clearFilter();
            tabulatorInstance.addFilter("terminal_code", "like", this.terminalSearchInput);
        }  else {
            tabulatorInstance.clearFilter();
        }
      },
      is_latest_formatter: function(cell, formatterParams, onRendered){
        var is_latest_format = ''
        var is_latest = cell.getValue();

        if (is_latest == 'Yes') 
          is_latest_format = "<span style='color: #00ff00;'><i class='fas fa-sync-alt'></i></span>"
        else
          is_latest_format = "<span style='color: #ff0000;'><i class='far fa-times-circle'></i></span>"

        return is_latest_format;
      },


    },
    mounted: async function () {
      component_x = this;
      this.apiURL = this.currentApiURL+'/?site_id='+secureStorage.getItem("defaultSiteId")
      this.data = await HTTPRequest.getRequest(component_x.apiURL);
    }
  }
</script>

<style lang='scss'>
@import "~vue-tabulator/dist/scss/bootstrap/tabulator_bootstrap";
</style>